import React, { Component } from "react";
import "./TotalCss.css";
import { SiteTitle } from "./SiteTitle";
import { FetchDataDomainTable } from "./FetchDataDomainTable";
import { api_url } from "./globalFunction/global_string";



export class DomainSet extends Component {
  static displayName = DomainSet.name;

  constructor(props) {
    super(props);
    this.state = {
      showModal: false, //初始化 modal 關閉
      isDataUnitNameFetched: false,
      isDataUnitUrlFetched: false,
      isDataFetched: true, // 初始化尚未取得資料
      fetchedData: {
        user_type: localStorage.getItem('login_user_type'),
        user_id: localStorage.getItem('login_user_id'),
        local_net_id: localStorage.getItem('login_user_net_id'),
        apiUrl: api_url + '/api/Async/GetListDomainData',
      }, // 初始化資料容器
    };
  }



  render() {
    return (
      <div>
        <SiteTitle />

        <div className="mt-5">
          <h1 id="tableLabel" className='mb-3'>使用者網域設定</h1>
          <div id="site_manage" className="row col-12 mb-5">

          </div>
          {this.state.isDataFetched && <FetchDataDomainTable
            fetchedData={this.state.fetchedData}
          />}
        </div>
      </div>
    )
  }
}